import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { MenuIconButton } from '@juvare/common-web-ui/MenuIconButton';
import { ModalSlideout, ModalSlideoutContent, ModalSlideoutTopBar } from '@juvare/common-web-ui/ModalSlideout';
import { ariaTitleId } from '@juvare/common-web-ui/ModalSlideout/ariaIds';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import AlertCardList from './AlertCardList';
export const AlertFabSlideout = (props) => {
    const { t } = useAlertUiTranslation();
    return (React.createElement(ModalSlideout, { open: props.isOpen, onClose: props.onClose, "data-test": 'alert-fab-slideout' },
        React.createElement(Box, { sx: {
                overflow: 'auto',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: themeColors.surface.primary,
            } },
            React.createElement(ModalSlideoutTopBar, { isOpaque: true, gradient: 'red-dark-linear' },
                React.createElement(Box, { sx: {
                        p: 1,
                        display: 'flex',
                        gap: 1,
                        alignItems: 'center',
                    } },
                    React.createElement(IconButton, { onClick: props.onClose, color: 'inherit', "data-test": 'slideout-close-button', "aria-label": t('common.close') },
                        React.createElement(CloseIcon, null)),
                    React.createElement(Typography, { id: ariaTitleId, variant: 'body1', noWrap: true, sx: { zIndex: (theme) => theme.zIndex.drawer + 1 } }, t('pages.toolbar.fabHeader')),
                    React.createElement(MenuIconButton, { sx: { ml: 'auto' }, menuItems: [
                            {
                                label: t('pages.newFromTemplate.createNewNotification'),
                                onClick: props.onAlertCreate,
                                'data-test': 'create-notification-menu-item',
                            },
                        ], "aria-label": t('common.moreActions') },
                        React.createElement(MoreHorizIcon, { "data-test": 'more-button' })))),
            React.createElement(Box, { sx: { pt: 8 } },
                React.createElement(ModalSlideoutContent, { ariaDescribeAllChildren: false },
                    React.createElement(AlertCardList, { handleSelect: props.onSelect, reloadFlag: props.reloadFlag }))))));
};
